module.exports = __webpack_public_path__ + "static/media/digital-work5.633d0c52.jpg";